'use strict';
import React from 'react';
import { Navigation } from 'react-router';
import flux from 'utils/flux';
import LoadingSpinner from 'components/spinner/spinner';

const ExcelSearchModal = React.createClass({
    displayName: 'ExcelSearchModal',
    mixins: [Navigation],

    getInitialState() {
        let excelRights = flux.getStore('media').getState().meta.toJS().excel_rights || JSON.parse(localStorage.getItem('excel_rights')) || [];
        const firstKey = excelRights[0] ? excelRights[0].key : null;
        return {
            uploadFile: null,
            selectedOption: firstKey,
            excelError: null,
            loading: false,
            submitClicked: false
        };
    },

    componentDidMount() {
        if (this.props.excelError) {
            flux.getActions('basket').clearErrorData();
        }
    },

    componentWillReceiveProps(nextProps) {
        if (!this.state.excelError && nextProps.excelError) {
            this.setState({excelError: nextProps.excelError, loading: false});
        }
    },

    handleOptionChange(changeEvent) {
        this.setState({ selectedOption: changeEvent.target.value });
    },

    handleInputChange(changeEvent) {
        this.setFile(changeEvent.target.files[0]);
    },

    handleFilePickerClick(clickEvent) {
        clickEvent.preventDefault();
        let inputNode = this.refs.hiddenFileInput.getDOMNode();
        inputNode.click();
    },

    setFile(file) {
        this.setState({ uploadFile: file });
    },

    activateLoading() {
        this.setState({ loading: true });
    },

    disableLoading() {
        this.setState({ loading: false });
    },

    submitForm() {
        if (!this.state.uploadFile) {
            this.setState({ submitClicked: true });
            return;
        }

        const formData = new FormData();
        formData.append('feature', this.state.selectedOption);
        formData.append('file', this.state.uploadFile);

        this.activateLoading();
        flux.getStore('basket').excelSearch(formData).then((data) => {
            this.disableLoading();
            let basketId = data.success;
            this.transitionTo('singleBasket', { id: basketId });
            flux.getActions('modals').closeModals();
        });
    },

    closeModal(e) {
        e.preventDefault();
        flux.getActions('modals').closeModals();
    },

    renderExcelRights() {
        const excelRights = flux.getStore('media').getState().meta.toJS().excel_rights || JSON.parse(localStorage.getItem('excel_rights')) || [];
        const radioButtons = excelRights.map((excelRight) =>
            <div className="form__group">
                <input type="radio" value={excelRight.key} checked={this.state.selectedOption === excelRight.key} onChange={this.handleOptionChange} />
                <span>{excelRight.value}</span>
            </div>
        );
        return radioButtons;
    },

    render() {
        var filePickerLabel = this.state.uploadFile ? this.state.uploadFile.name : flux.t('no_file_selected');
        var isRedText = !this.state.uploadFile && this.state.submitClicked;
        return (
            <div>
                <h4>{flux.t('excel_search')}</h4>
                {this.state.loading ?
                <LoadingSpinner />
                :
                this.state.excelError ?
                    <div>
                        <p className="errorMessage">{flux.t('excel_search_error')}</p>
                        <textarea className="errorMessage" disabled={true}>{this.state.excelError}</textarea>
                    </div>
                    :
                    <form>
                        <p><b>{flux.t('excel_description')}</b></p>
                        <p>{flux.t('excel_info')}</p>
                        {this.renderExcelRights()}
                        {/* <input type="file" onChange={this.handleInputChange} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" /> */}
                        <div className="form__group">
                            <button className="btn btn-border btn__modal__submit" onClick={this.handleFilePickerClick}>
                                {flux.t('choose_file')}
                            </button>
                            <input
                                type="file"
                                ref="hiddenFileInput"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                onChange={this.handleInputChange}
                                style={{ display: 'none' }}
                            />
                            <div className="form__btn__label" style={isRedText ? {color: "#ff3838"} : {} }>{filePickerLabel}</div>
                        </div>

                        <div className="form__group form__group__submit">
                            <button className="btn btn-border btn__modal__submit" onClick={this.submitForm} disabled={this.state.loading}>{flux.t('upload_file')}</button>
                        </div>
                    </form>
                }
            </div>
        );
    }
});

module.exports = ExcelSearchModal;


// WEBPACK FOOTER //
// ./app/components/modals/excelSearchModal.jsx